var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassappIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156.5 134.6",
    style: {
      enableBackground: "new 0 0 156.5 134.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#015EDB;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.2,62.5c0-32.8-34-59.4-76-59.4s-76,26.6-76,59.4s34,59.4,76,59.4c6.6,0,13.2-0.7,19.6-2.1l23.1,11.6v-19.8 C141.1,100.9,154.2,82.9,154.2,62.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.25,
    y1: 84.3553,
    x2: 140.5,
    y2: 84.3553,
    gradientTransform: "matrix(1 0 0 -1 0 136.5907)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03AC6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#FAB23B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EC355E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,67.3C7,34.5,41,7.9,83,7.9c23,0,43.6,8,57.5,20.6C126.8,13.2,104,3.2,78.2,3.2c-42,0-76,26.6-76,59.4 c0,14.8,7,28.3,18.5,38.8C12.1,91.7,7,80,7,67.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83,45.9v49.9c0,0,18.7-7.1,38-7.1V38.8C101.7,38.8,83,45.9,83,45.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.5,45.9v49.9c0,0-18.7-7.1-38-7.1V38.8C54.8,38.8,73.5,45.9,73.5,45.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassappIcon);
export default __webpack_public_path__ + "static/media/classapp_icon.4617a3105cbd77add0a933260564a2b0.svg";
export { ForwardRef as ReactComponent };